// components/RequestDetailCard.jsx
import React from "react";
import { Box, Typography, Chip, Paper } from "@mui/material";

const StatusChip = ({ confirmedAt, refusedAt }) => {
  if (confirmedAt)
    return <Chip label="Confermato" color="success" size="small" variant="filled" />;
  if (refusedAt)
    return <Chip label="Rifiutato" color="error" size="small" variant="filled" />;
  return <Chip label="In attesa" color="default" size="small" variant="outlined" />;
};

const RequestDetailCard = ({ fromDescription, toDescription, confirmedAt, refusedAt, t }) => {
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 2, 
        bgcolor: "#f8f9fa", 
        border: "1px solid #e0e0e0", 
        borderRadius: 2 
      }}
    >
      <Typography variant="body2" sx={{ mb: 1 }}>
        <strong>{t("Il mio turno")}:</strong> {fromDescription}
      </Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        <strong>{t("Con il turno")}:</strong> {toDescription}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
        <strong>{t("Stato")}:</strong>
        <StatusChip confirmedAt={confirmedAt} refusedAt={refusedAt} />
      </Box>
    </Paper>
  );
};

export default RequestDetailCard;